import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatDocumentType'
})
export class FormatDocumentTypePipe implements PipeTransform {

  typeDocument = '';

  transform(value: string): string {
    const documentMap: { [key: string]: string } = {
      'CO1C': 'CC',
      '2': 'CC',
      'CC': 'CO1C',
      'CO1N': 'NIT',
      '1': 'NIT',
      'NIT': 'CO1N',
      'CO1E': 'CE',
      '3': 'CE',
      'CE': 'CO1E',
      'CO1T': 'TI',
      '4': 'TI',
      'TI': 'CO1T',
      'CO1L': 'RC',
      '5': 'RC',
      'RC': 'CO1L',
      'CO1P': 'P',
      '7': 'P',
      'P': 'CO1P',
      'CO1D': 'CN',
      'CN': 'CO1D',
      'CO1S': 'SIDE',
      'SIDE': 'CO1S',
      'CO1V': 'PEDP',
      '8': 'PEDP',
      'PEDP': 'CO1V',
      'CO1W': 'PT',
      '9': 'PT',
      'PT': 'CO1W',
      'CO1X': 'TE',
      'TE': 'CO1X',
    };
  
    return documentMap[value] || this.typeDocument;
  }
}
